import { Component, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from '../auth/auth.service';
import { Constant } from '../constant';
import { Title } from '@angular/platform-browser';
import { CommonUtil } from '../util/common-util';
import { ToastUtil } from '../util/toast-util';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ManagerEditDialogComponent } from '../dialog/manager-edit-dialog/manager-edit-dialog.component';
import { ConcurrentEditDialogComponent } from '../dialog/concurrent-edit-dialog/concurrent-edit-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PermissionInfoComponent } from '../permission-info/permission-info.component';

interface OrgNode {
  id: number;
  name: string;
  children?: OrgNode[];
  path?: string;
  checked?: boolean;
  manual?: boolean;
}
@Component({
    selector: 'account-about',
    templateUrl: './account-about.component.html',
    styleUrl: './account-about.component.css',
    standalone: true,
    imports: [
      MatMenuModule,
      MatButtonModule,
      MatIconModule,
      CommonModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      MatSelectModule,
      MatInputModule,
      MatCheckboxModule,
      MatProgressSpinnerModule,
      PermissionInfoComponent
    ]
})
export class AccountAboutComponent {
  public tellNo = Constant.calinTellNo + Constant.calinWorkTime;
  public supportMail = Constant.calinSupportMail;
  public accounts;
  public isSaving = false;
  public tagMaster;
  public apiPath = '/company';
  public readonly Constant = Constant;
  public showSpinner = true;
  public form: FormGroup;
  public affiliationLarges = [];
  public affiliationMiddles = [];
  public affiliationSmalls = [];
  public officialPositions = [];
  public selectedOrgs: any[] = [];
  public selectedConcurrent: any[] = [];
  public isMasterAccount = false;
  /** SP（767px以下）。役職の選択肢の一覧を、固定幅（352px）ではなく入力欄と同じ幅にする */
  public readonly isSp = window.matchMedia('(max-width: 767px)').matches;

  private operator;
  private masters;

  constructor(
    private title: Title,
    private router: Router,
    private commonUtil: CommonUtil,
    private toastUtil: ToastUtil,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.title.setTitle(Constant.pageTitleAccountAbout + Constant.pageTitleCommon);
  }

  @HostListener('window:focus')
  onFocus(): void {
    this.commonUtil.checkRefreshToken(this.auth);
  }

  ngOnInit() {
    window.scroll(0, 0);
    if (!this.commonUtil.checkOnline()) {
      this.showSpinner = false;
      return;
    }
    // 記事データを取得する
    this.getData();
  }

  formatDate(dateStr: string): string {
    //return this.datePipe.transform(
    //  dateStr.replace(' ', 'T'), // MySQL形式対策
    //  'yyyy/MM/dd HH:mm',
    //  'Asia/Tokyo'
    //)!;
    const date = new Date(dateStr.replace(' ', 'T') + 'Z');

    return date.toLocaleString('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  }

  onSave() {
    if (!this.commonUtil.checkOnline()) {
      this.isSaving = false;
      return;
    }

    if (this.isSaving) {
      return;
    }

    this.isSaving = true;
      this.dataUpdate();
  }

  /*
   * プライベート関数
   */

  // 記事情報を取得する
  private getData() {
    if (!this.commonUtil.isOnline()) {
      this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
      return;
    }
    this.showSpinner = true;
    Auth.currentSession().then(session => {
      const options = this.auth.createApiHeader(session);

      Promise.all([
        this.commonUtil.apiGet('/master', options),
        this.commonUtil.apiGet('/myaccount', options)
      ])
      .then(([masterRes, operatorRes]) => {

        if (!operatorRes.data) {
          // 削除済み
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgDeleteContentAlreadyError, Constant.toastShowMiliSec);
          return;
        }

        this.masters = masterRes.data.master;;
        this.operator = operatorRes.data;
        this.isMasterAccount = !!this.operator.is_master_account;

        console.log(this.operator)

        this.setMasterData();
        this.initForm();

        this.showSpinner = false;
      })
      .catch(err => {
        this.commonUtil.debug().log(err);
        if (err.message === Constant.msgLoginFailed) {
          this.commonUtil.showReloadDialog(this.auth);
        } else{
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
        }
      });
    });
  }

  private setMasterData() {

    if (!this.masters) {
      console.error("masterData not found", !this.masters);
      return;
    }

    // 大分類は固定
    this.affiliationLarges = [
      { label: '本部マスタ', value: '1' },
      { label: '支部マスタ', value: '2' },
      { label: 'エリアマスタ', value: '3' }
    ];

    // 役職
    this.officialPositions =
      ((this.masters[5] as any[]) || []).map(m => ({
        label: m.name,
        value: String(m.id)
      }));
  }

  // 権限（マスターアカウントは常に「管理（固定）」、一般ユーザは役職に紐づく値）
  get authorityLabel(): string {
    if (this.isMasterAccount) {
      return '管理（固定）';
    }
    const labels: { [key: number]: string } = {
      0: '管理', 1: '準管理', 2: '運用', 3: 'メンバー', 4: 'なし（未承認）'
    };
    return labels[this.operator?.user_authority] ?? 'なし（未承認）';
  }

  private initForm() {
    this.form = new FormGroup({
      LastName: new FormControl(this.operator.last_name, Validators.required),
      firstName: new FormControl(this.operator.firstName, Validators.required),

      officialPosition: new FormControl(
        { value: String(this.operator.officialposition), disabled: !this.isMasterAccount }
      ),
      isFullTime: new FormControl(!!this.operator.isfulltime),
      org_count: new FormControl(),
    });

    this.selectedOrgs = this.operator.organizations.map(org => ({
      ...org,
      path: org.level === 0
        ? org.path
        : `${this.getMasterTypeName(org.master_type)} ${org.path}`
    }));
    this.selectedConcurrent = this.operator.concurrent_organizations

    this.setupAffiliationWatcher();

    this.initializeAffiliation();
  }

  private getMasterTypeName(master_type: number): string {
    switch(master_type) {
      case 1: return '本部';
      case 2: return '支部';
      case 3: return 'エリア';
      default: return '';
    }
  }

  onOrgCountInput(event: any, index: number) {
    const input = event.target as HTMLInputElement;

    // 数字以外を削除
    let numericVal = input.value.replace(/\D/g, '');

    // 空の場合は 0 に
    numericVal = numericVal === '' ? '' : numericVal;

    // 入力欄に反映（ビューに即反映）
    input.value = numericVal;

    // selectedOrgs に反映
    if (this.selectedOrgs && this.selectedOrgs[index]) {
      this.selectedOrgs[index].org_count = Number(numericVal);
    }
  }

  private setupAffiliationWatcher() {

    // 大分類変更
    this.form.get('affiliationLarge')?.valueChanges.subscribe(value => {

      this.affiliationMiddles =
        (this.masters[value] || []).map(m => ({
          label: m.name,
          value: String(m.id)
        }));

      this.affiliationSmalls = [];
      this.form.patchValue({
        affiliationMiddle: null,
        affiliationSmall: null
      });
    });

    // 中分類変更 → 小分類更新
    this.form.get('affiliationMiddle')?.valueChanges.subscribe(value => {

      const large = this.form.value.affiliationLarge;

      const middleList = this.masters[large] || [];

      const selectedMiddle = middleList.find(m => String(m.id) === value);

      if (!selectedMiddle || !selectedMiddle.children) {
        this.affiliationSmalls = [];
        return;
      }

      this.affiliationSmalls =
        selectedMiddle.children.map(c => ({
          label: c.name,
          value: String(c.id)
        }));
    });
  }

  private initializeAffiliation() {

    const large = this.form.value.affiliationLarge;
    const middle = this.form.value.affiliationMiddle;

    if (!large) return;

    // 中分類生成
    this.affiliationMiddles =
      (this.masters[large] || []).map(m => ({
        label: m.name,
        value: String(m.id)
      }));

    if (!middle) return;

    // 小分類生成
    const selectedMiddle =
      (this.masters[large] || []).find(m => String(m.id) === middle);

    if (selectedMiddle && selectedMiddle.children) {
      this.affiliationSmalls =
        selectedMiddle.children.map(c => ({
          label: c.name,
          value: String(c.id)
        }));
    }
  }

  // トースト表示
  private showToast(msg) {
    this.toastUtil.clearAllShowingToast();
    this.toastUtil.showInformationToast(Constant.empty, msg, Constant.toastShowMiliSec);
  }

  // エラートースト表示
  private showErrorToast(msg) {
    this.toastUtil.clearAllShowingToast();
    this.toastUtil.showErrorToast(Constant.empty, msg, Constant.toastShowMiliSec);
  }

  onSelectChange(select: any) {
    event.preventDefault();
    event.stopPropagation();

    select.close();
    (document.activeElement as HTMLElement)?.blur();
  }

  onManger() {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    if (!this.commonUtil.isOnline()) {
      this.showErrorToast(Constant.msgNetworkError);
      return;
    }

    const dialogRef = this.dialog.open(ManagerEditDialogComponent, {
      data: {
        selected: this.selectedOrgs
      },
      width: Constant.managerEditDialogWidth,
      maxWidth: 'calc(100vw - 32px)',
      maxHeight: 'calc(100vh - 32px)',
      panelClass: ['manager-edit-dialog-large-font', 'responsive-dialog'],
      height: '664px',
      autoFocus: false,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result !== Constant.empty) {
        this.selectedOrgs = result; // ← 保存
      }
    });
  }

  onConcurrent() {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    if (!this.commonUtil.isOnline()) {
      this.showErrorToast(Constant.msgNetworkError);
      return;
    }

    const dialogRef = this.dialog.open(ConcurrentEditDialogComponent, {

      data: {
        selected: this.selectedConcurrent   // 既選択を渡す場合
      },
      width: Constant.managerEditDialogWidth,
      maxWidth: 'calc(100vw - 32px)',
      panelClass: 'responsive-dialog',
      autoFocus: false,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== Constant.empty) {
        this.selectedConcurrent = result;
      }
    });
  }

  private isRootOrg(name: string): boolean {
    return ['本部', '支部', 'エリア'].includes(name);
  }

  // 登録実行
  private dataUpdate() {

    Auth.currentSession().then(session => {

      const options = this.auth.createApiHeader(session);

      const orgsPayload = this.selectedOrgs.map(org => {

        // 本部・支部・エリアだけ特別扱い
        if (this.isRootOrg(org.name) && org.level === 0) {
          return {
            name: org.name,
            level: org.level,
            master_type: org.master_type,
            count: org.org_count || 0
          };
        }

        // それ以外は従来通り
        return {
          id: org.id,
          level: org.level,
          master_type: org.master_type,
          count: org.org_count || 0
        };
      });

      const concurrentPayload = this.selectedConcurrent.map(con => ({
        name: con.name,
        id: con.id,
        master_type: 4,
      }));

      const selectedPosition = this.form.value.officialPosition;

      const isValidPosition = this.officialPositions.some(
        pos => pos.value === selectedPosition
      );

      options['body'] = {

        last_name: this.form.value.LastName,
        first_name: this.form.value.firstName,

        officialposition: isValidPosition ? selectedPosition : null,

        // boolean → DB用数値変換
        isfulltime: this.form.value.isFullTime ? 1 : 0,
        organizations: orgsPayload,
        concurrent_organizations: concurrentPayload
      };

      console.log(options)

      this.commonUtil
        .apiPut('/myaccount', options)   // ← APIパスに合わせて変更
        .then(res => {

          if (res.status === Constant.OK) {
            this.toastUtil.showInformationToast(
              '',
              Constant.msgResultSaveSuccess,
              Constant.toastShowMiliSec
            );
            this.getData();
          }

          this.isSaving = false;
        })
        .catch(err => {

          this.commonUtil.debug().log(err);
          if (err.message === Constant.msgLoginFailed) {
            this.commonUtil.showReloadDialog(this.auth);
          } else {
            this.toastUtil.showErrorToast(
              '',
              Constant.msgSaveFailedRetry,
              Constant.toastShowMiliSec
            );
          }

          this.isSaving = false;
        });
    });
  }
}
